// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GrNdQ","newExpiryDate":"styles_newExpiryDate__1Xfth","footer":"styles_footer__OYIdy"};